<template>
    <div id="popup-alert-modal" class="modal modal-lg fade" role="dialog">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-body">
                    <div class="row mt-3 mb-3">
                        <div class="col col-auto align-self-center">
                            <b-icon icon="exclamation-octagon" />
                        </div>
                        <div class="col">
                            <p>
                            Toto je výstup Kontroly rizik veřejných zakázek provedený společností Datlab. Její závěry nedokazují pochybení či porušení zákona.
                            Zjištěná rizika znamenají pouze vyšší možnost výskytu takových situací. Neměla by proto sama o sobě být kladena k tíži zadavatele ani dodavatele.
                            Kontrola jako celek má sloužit jako vstup pro lepší nastavení vnitřních kontrolních postupů či hloubkový audit.
                            </p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col align-self-center align-right">
                        </div>
                        <div class="d-grid">
                            <button type="button" @click="closeModal" class="btn btn-outline-primary btn-sm">{{ $t('button.close') }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Modal } from "bootstrap";

export default {
    data() {
        return {
            alertModal: null
        }
    },
    mounted: function() {
        if (!this.$cookies.get('analysis-caveat-shown')) {
            this.alertModal = new Modal(document.getElementById("popup-alert-modal"),{ keyboard: false });
            this.alertModal.show();
            this.$cookies.set('analysis-caveat-shown', true, '7d')
        }
    },
    methods: {
        closeModal: function() {
            this.alertModal.hide();
        },
    },
}
</script>

<style lang="scss">
@use "@/scss/custom";

#popup-alert-modal {
    .modal-header {
        border-bottom: none;
    }

    .modal-content {
        .col:first-of-type {
            font-size: 50px;
        }

        p {
            font-size: 20px;
        }
    }
}
</style>